import { Payout, PayoutProviderName } from '../entity'

export const isPaidOffline = (payout: Payout) => payout.provider.name === PayoutProviderName.GUIKER
